var exports = {
  "i": "x31de4314--d8213d--wrapper",
};

module.exports = exports;
